import React from 'react'

const Aboutus = () =>{
    return (
        <h1 className="text-center">Coming Soon</h1>
    )
}

export default Aboutus